import React from "react";
import { Calendar, Info } from "lucide-react";
import { cn } from "@shared/lib/utils";

export type InfoItem = {
  label: string;
  value: any;
  subtext?: any;
  icon?: React.ReactNode;
  isLink?: boolean;
};

type InfoCardProps = {
  title: string;
  sections: InfoItem[][];
  className?: string;
};

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  sections,
  className,
}) => {
  return (
    <div
      className={cn("bg-white rounded-md shadow-sm border w-full", className)}
    >
      <h4 className="text-sm font-semibold text-gray-700 bg-muted mb-4 text-center p-2 border-b">
        {title}
      </h4>
      <div className="grid grid-cols-2 gap-4 p-4">
        {sections.map((group, groupIdx) => (
          <div key={groupIdx} className="space-y-2">
            {group.map(({ label, value, subtext, icon, isLink }, idx) => (
              <div key={idx}>
                <div className="text-xs text-gray-500">{label}</div>
                <div className="flex items-center gap-1 text-base font-semibold text-gray-900">
                  {isLink && value ? (
                    <a
                      href={value}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary underline"
                    >
                      View Image
                    </a>
                  ) : (
                    value ?? "NA"
                  )}
                  {icon && <span className="text-gray-400">{icon}</span>}
                </div>
                {subtext && (
                  <div className="text-xs text-gray-500">{subtext ?? "NA"}</div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
